import { ajaxSend } from 'api/api';
const basePath = '/v1/teams';
export const getTeams = (params = {}) => ajaxSend({
    path: basePath,
    params: params,
});
export const getTeam = (teamId) => ajaxSend({ path: `${basePath}/${teamId}` });
export const createTeam = (data) => ajaxSend({
    path: basePath,
    method: 'POST',
    data,
});
export const removeTeam = (teamId) => ajaxSend({
    method: 'DELETE',
    path: `${basePath}/${teamId}`,
});
